$(document).ready(function() {

  $('.js-infinite-scroll-wrapper').sw_infinite_scroll();

  const observer = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        $(mutation.addedNodes).find('.js-infinite-scroll-wrapper').sw_infinite_scroll();
      }
    }
  });
  observer.observe(document, {
    subtree:true,
    childList:true,
  });

});

$(window).scroll(function() {
  $('.js-infinite-scroll-wrapper').each(function() {
    let i = $(this).data('sw-infinite-scroll');
    if ( i ) {
      i.on_scroll();
    }
  });
});

class SwInfiniteScroll {

  constructor($wrap) {
    let _this = this;

    this.$wrap = $wrap;

    this.id = this.$wrap.attr('id');
    this.loading = false;
    this.is_load_on_scroll = !this.$wrap.hasClass('js-infinite-scroll-wrapper--no-scroll-load');

    this.$wrap.on('click', '.js-infinite-scroll-button-wrap a', function (e) {
      e.preventDefault();
      _this.load_more($(this));
    });

    this.$wrap.data('sw-infinite-scroll', this);
  }

  on_scroll() {
    if (!this.is_load_on_scroll) {
      return;
    }
    let $bw = this.$wrap.find('.js-infinite-scroll-button-wrap');
    if ($bw.length) {
      let st = $(window).scrollTop();
      let wh = $(window).height();
      let bot = $bw.offset().top;
      if (st + wh > bot + 100) {
        this.load_more($bw.find('a').first());
      }
    }
  }

  load_more($a) {
    let _this = this;
    if (this.loading) {
      return;
    }
    this.loading = true;
    let ta = $a.text();
    $a.text('Loading...');
    //$a.append(wait());
    $a.addClass('disabled');
    this.ajax = $.ajax({
      url: $a.attr('href'),
      method: 'GET',
      dataType: 'html',
      success: function (resp) {
        _this.$wrap.find('.js-infinite-scroll-button-wrap').remove();
        _this.$wrap.append($(resp).find('#' + _this.id + '.js-infinite-scroll-wrapper').html());

        // Update drupal settings global vars
        // const $drupal_settings = $(resp).filter('script[data-drupal-selector="drupal-settings-json"]');
        // if ($drupal_settings.length) {
        //   drupalSettings = $.extend(drupalSettings, JSON.parse($drupal_settings[0].textContent));
        //   // console.log(drupalSettings);
        // }

        // Drupal.attachBehaviors(false);
        _this.loading = false;
      },
      error: function (xhr, status, error) {
        console.error('AJAX error! ' + status + ', ' + error);
        $a.text('Unable to load')
        setTimeout(function () {
          $a.text(ta);
          $a.removeClass('disabled');
          _this.loading = false;
        }, 1000);
      }
    });
  }
}

sw_jquery_widget_add(SwInfiniteScroll, 'sw_infinite_scroll');
